import * as React from 'react';
import { Button } from '@bytebrand/fe-ui-core-autobahn/ui';
import { Trans } from 'react-i18next';
import { USER_TERMS_LINK, DEALER_TERMS_LINK, ERROR_CODE_VEHICLE_DAMAGED } from '../../../framework/constants/dealer';
import styles from './QualityRestrictionModal.styl';
class QualityRestrictionModal extends React.Component {
    render() {
        const { t, isDealer, onClose, errorCode } = this.props;
        const MODAL_LINK = isDealer ? DEALER_TERMS_LINK : USER_TERMS_LINK;
        const MODAL_TEXT = isDealer ? 'dealerText' : 'customerText';
        return (React.createElement("div", { className: styles.modal },
            errorCode === ERROR_CODE_VEHICLE_DAMAGED
                ? React.createElement("p", null, t('MyVehiclesPage:qualityRestrictionModal.errorTextDamaged'))
                : React.createElement("p", null, t('MyVehiclesPage:qualityRestrictionModal.errorText')),
            React.createElement(Trans, { i18nKey: `MyVehiclesPage:qualityRestrictionModal.${MODAL_TEXT}` },
                React.createElement("p", null,
                    "Our quality criteria can be found here in our dealer ",
                    React.createElement("a", { href: MODAL_LINK, target: '_blank', className: styles.externalLink }, "terms and conditions"),
                    "."),
                React.createElement("p", null, "Furthermore, all our comprehensive services are available for your complete vehicle list."),
                React.createElement("p", null, "Your auto.de team")),
            React.createElement("div", { className: styles.textAlignCenter },
                React.createElement(Button, { variant: 'filled', onClick: onClose, className: styles.closeButton }, t('MyVehiclesPage:qualityRestrictionModal.closeButton')))));
    }
}
export default QualityRestrictionModal;
